import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0fe9fbfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container mx-auto",
  style: {"margin-bottom":"120px"}
}
const _hoisted_2 = {
  key: 0,
  class: "font-extrabold text-center mb-6 uppercase lg-text-32px text-20px"
}
const _hoisted_3 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-3 gap-6 px-4"
}
const _hoisted_4 = { class: "space-y-6" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "flex flex-col space-y-6" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["src"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "flex flex-col space-y-6" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["src"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  key: 2,
  class: "mt-6 flex justify-center"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" See more ")
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div style=\"margin-top:120px;\" data-v-0fe9fbfa><div class=\"mb-6 font-semibold text-2xl text-center\" data-v-0fe9fbfa> Share this with your friends :D </div><div class=\"flex items-center justify-center\" data-v-0fe9fbfa><a target=\"_blank\" href=\"https://www.facebook.com/dialog/share?app_id=638148823966597&amp;display=popup&amp;href=https://www.bringbacktheforest.com\" class=\"flex px-4 py-2 rounded-lg cursor-pointer\" style=\"background:#1877f2;\" data-v-0fe9fbfa><img style=\"height:28px;\" src=\"/images/our-forest/social/facebook-white-circle.png\" alt=\"\" data-v-0fe9fbfa><span class=\"font-semibold text-2xl text-white ml-3\" data-v-0fe9fbfa>Share</span></a><a target=\"_blank\" href=\"https://twitter.com/intent/tweet?text=https://www.bringbacktheforest.com&amp;hashtags=bringBackTheForest\" class=\"flex px-4 py-2 rounded-lg cursor-pointer ml-6\" style=\"background:#1da1f2;\" data-v-0fe9fbfa><img class=\"w-7\" src=\"/images/our-forest/social/twitter.png\" alt=\"\" data-v-0fe9fbfa><span class=\"font-semibold text-2xl text-white ml-3\" data-v-0fe9fbfa>Share</span></a></div></div>", 1)

import useForest from '@/composables/useForest';
import { ref, onMounted } from 'vue';
import { PageInfo } from '@/types/Forest';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { forestGalleries, forestDetail, getForestGalleries, formatDate } =
  useForest();

const gallery = ref();
const pageInformation = ref<PageInfo>({
  count: 0,
  last_page: 0,
  page: 0,
  size: 0,
});
onMounted(async () => {
  await getForestGalleries({ page: 1, size: 6 });
  gallery.value = forestGalleries.value?.entities;
  pageInformation.value = forestGalleries.value?.page_information as PageInfo;
});

return (_ctx: any,_cache: any) => {
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(forestDetail))
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(forestDetail).name) + "," + _toDisplayString(_unref(forestDetail).country), 1))
      : _createCommentVNode("", true),
    (pageInformation.value.count > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (gallery.value[0])
              ? (_openBlock(), _createElementBlock("figure", _hoisted_5, [
                  _createElementVNode("img", {
                    src: gallery.value[0].image.original_image_url,
                    class: "img--small",
                    alt: "forest-gallery"
                  }, null, 8, _hoisted_6),
                  _createElementVNode("figcaption", null, _toDisplayString(_unref(formatDate)(gallery.value[0].updated_at)), 1)
                ]))
              : _createCommentVNode("", true),
            (gallery.value[3])
              ? (_openBlock(), _createElementBlock("figure", _hoisted_7, [
                  _createElementVNode("img", {
                    src: gallery.value[3].image.original_image_url,
                    class: "img--big",
                    alt: "forest-gallery"
                  }, null, 8, _hoisted_8),
                  _createElementVNode("figcaption", null, _toDisplayString(_unref(formatDate)(gallery.value[3].updated_at)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (gallery.value[1])
              ? (_openBlock(), _createElementBlock("figure", _hoisted_10, [
                  _createElementVNode("img", {
                    src: gallery.value[1].image.original_image_url,
                    class: "img--big",
                    alt: "forest-gallery"
                  }, null, 8, _hoisted_11),
                  _createElementVNode("figcaption", null, _toDisplayString(_unref(formatDate)(gallery.value[1].updated_at)), 1)
                ]))
              : _createCommentVNode("", true),
            (gallery.value[4])
              ? (_openBlock(), _createElementBlock("figure", _hoisted_12, [
                  _createElementVNode("img", {
                    src: gallery.value[4].image.original_image_url,
                    class: "img--small",
                    alt: "forest-gallery"
                  }, null, 8, _hoisted_13),
                  _createElementVNode("figcaption", null, _toDisplayString(_unref(formatDate)(gallery.value[4].updated_at)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (gallery.value[2])
              ? (_openBlock(), _createElementBlock("figure", _hoisted_15, [
                  _createElementVNode("img", {
                    src: gallery.value[2].image.original_image_url,
                    class: "img--small",
                    alt: "forest-gallery"
                  }, null, 8, _hoisted_16),
                  _createElementVNode("figcaption", null, _toDisplayString(_unref(formatDate)(gallery.value[2].updated_at)), 1)
                ]))
              : _createCommentVNode("", true),
            (gallery.value[5])
              ? (_openBlock(), _createElementBlock("figure", _hoisted_17, [
                  _createElementVNode("img", {
                    src: gallery.value[5].image.original_image_url,
                    class: "img--big",
                    alt: "forest-gallery"
                  }, null, 8, _hoisted_18),
                  _createElementVNode("figcaption", null, _toDisplayString(_unref(formatDate)(gallery.value[5].updated_at)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (pageInformation.value.last_page > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_router_link, {
            to: `/landing/galleries/${_ctx.$route.params.id}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_BaseButton, {
                "color-scheme": "border",
                style: {"font-weight":"700 !important"}
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true),
    _hoisted_21
  ]))
}
}

})